import { Link, useLocation } from "react-router-dom";
import { Home, Grid3X3, Search, User, ShoppingCart } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { cn } from "@/lib/utils";

const navItems = [
  { icon: Home, label: "Home", href: "/" },
  { icon: Grid3X3, label: "Categories", href: "/shop" },
  { icon: Search, label: "Search", href: "/shop?focus=search" },
  { icon: User, label: "Account", href: "/account" },
  { icon: ShoppingCart, label: "Cart", href: "/cart", showBadge: true },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const { itemCount } = useCart();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border shadow-lg pb-safe" aria-label="Mobile navigation">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href || 
            (item.href === "/shop" && location.pathname.startsWith("/shop"));
          
          return (
            <Link
              key={item.label}
              to={item.href}
              aria-label={item.showBadge && itemCount > 0 ? `${item.label}, ${itemCount} items` : item.label}
              aria-current={isActive ? "page" : undefined}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full min-h-[48px] relative transition-colors",
                isActive ? "text-coral" : "text-muted-foreground"
              )}
            >
              <div className="relative">
                <item.icon className="h-6 w-6" aria-hidden="true" />
                {item.showBadge && itemCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-coral text-white text-[10px] rounded-full h-4 w-4 flex items-center justify-center font-bold" aria-hidden="true">
                    {itemCount > 9 ? "9+" : itemCount}
                  </span>
                )}
              </div>
              <span className="text-[11px] mt-1 font-medium" aria-hidden="true">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
